<div class="onb-layout font-poppins min-h-screen flex flex-col bg-white">
  <app-navbar [toogle]="toogle" (isToogle)="toogle = $event"></app-navbar>
  <app-menu [toogle]="toogle" (changeToogle)="toogle = $event"></app-menu>

  <main class="flex-1 pt-14">
    <ng-container *ngIf="vm$ | async as vm">
      <header *ngIf="vm.step" class="onb-header max-w-screen-lg mx-auto px-4 pt-8 md:pt-12">
        <h1 class="onb-title text-center text-journey-title font-extrabold text-[20px] sm:text-2xl md:text-[30px] leading-snug text-balance max-w-3xl mx-auto">{{ vm.title }}</h1>
        <app-journey-stepper class="block mt-6 md:mt-9 max-w-3xl mx-auto" [current]="vm.step"></app-journey-stepper>
      </header>
    </ng-container>

    <section class="onb-content max-w-screen-lg mx-auto px-4 md:px-8 pt-6 md:pt-10 *:w-full">
      <router-outlet></router-outlet>
    </section>
  </main>

  <app-journey-footer></app-journey-footer>
</div>
